export const DEFAULT_ELECTRONIC_IDENTIFIER = '0195';
export const DEFAULT_PEPPOL_SCHEME = 'iso6523-actorid-upis';
export const DEFAULT_PEPPOL_ID_PREFIX = 'SGTST';
export const DEFAULT_CURRENCY_CODE = 'AED';
export const UAE_COUNTRY_CODE = 'AE';
export const RCM_TAX_CATEGORY_CODE = 'AE';
export const DEFAULT_TAX_SCHEME = 'VAT';

export function isNoTaxScheme(taxScheme) {
  return taxScheme == null || taxScheme === '';
}
export const DEFAULT_DOCUMENT_SOURCE = 'WEB';
export const SALES = 'sales';
export const PURCHASES = 'purchases';
export const DEFAULT_CUSTOMER_TYPE = 'BUSINESS';

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;

// Allowance calculation types
export const PERCENTAGE = 'PERCENTAGE';
export const ABSOLUTE = 'ABSOLUTE';
export const ALLOWANCE = 'ALLOWANCE';
export const CHARGE = 'CHARGE';

// document type code
export const INVOICE_DOCUMENT_TYPE_CODE = '380';
export const SELF_BILLED_INVOICE_DOCUMENT_TYPE_CODE = '389';
export const OUT_OF_SCOPE_INVOICE_CODE = '480';
export const CREDIT_NOTE_DOCUMENT_TYPE_CODE = '381';
export const SELF_BILLED_CREDIT_NOTE_DOCUMENT_TYPE_CODE = '261';
export const GOODS_AND_SERVICE_CN_CODE = '81';

export const DEFAULT_TRANSITION_TYPE_CODE = '00000000';
